package one.healthium.insights.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEach
import ifaandroid.feature.content.insights.generated.resources.Res
import ifaandroid.feature.content.insights.generated.resources.ic_bookmark_24
import ifaandroid.feature.content.insights.generated.resources.ic_bookmark_filled_24
import ifaandroid.feature.content.insights.generated.resources.ic_refresh_24
import loco.CONTENT_SHOPPING_LIST_BUTTON
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.ui.models.NavBarUiModel
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black50
import one.healthium.ui.compose.theme.white
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun ContentAppBarActions(
    uiModel: NavBarUiModel,
    onActionClicked: (ActionModel) -> Unit,
) {
    uiModel.actions?.fastForEach { action ->
        when (action) {
            is ActionModel.ShoppingList -> {
                Row(
                    modifier = Modifier.Companion
                        .clip(CircleShape)
                        .clickable(onClick = { onActionClicked(action) })
                        .background(black50, CircleShape)
                        .padding(horizontal = 12.dp, vertical = 9.dp),
                    verticalAlignment = Alignment.Companion.CenterVertically,
                ) {
                    Icon(
                        painter = painterResource(AppIcons.icCart),
                        tint = white,
                        contentDescription = null,
                    )
                    Spacer(Modifier.Companion.width(4.dp))
                    Text(
                        text = stringResource(loco.Res.string.CONTENT_SHOPPING_LIST_BUTTON),
                        style = AppTheme.textStyles.secondary_14_500,
                        color = white,
                    )
                }
            }

            is ActionModel.UpdateFoodPreferences -> {
                IconButton(
                    icon = Res.drawable.ic_refresh_24,
                    onClick = { onActionClicked(action) },
                )
            }

            is ActionModel.Favorite -> {
                val hapticFeedback = LocalHapticFeedback.current
                IconButton(
                    icon = if (uiModel.isFavorite) Res.drawable.ic_bookmark_filled_24 else Res.drawable.ic_bookmark_24,
                    onClick = {
                        hapticFeedback.performHapticFeedback(
                            hapticFeedbackType =
                                if (uiModel.isFavorite) HapticFeedbackType.ToggleOff
                                else HapticFeedbackType.ToggleOn
                        )
                        onActionClicked(action)
                    },
                )
            }

            else -> Unit
        }
    }
}

@Composable
private fun IconButton(
    modifier: Modifier = Modifier,
    icon: DrawableResource,
    onClick: () -> Unit,
) {
    Box(
        modifier = modifier
            .clip(CircleShape)
            .clickable(onClick = onClick)
            .background(black50, CircleShape)
            .padding(6.dp),
    ) {
        Icon(
            painter = painterResource(icon),
            tint = white,
            contentDescription = null,
        )
    }
}